module.exports = __webpack_public_path__ + "static/img/5.4cfb068.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/5.png
// module id = NZeG
// module chunks = 0